import React from 'react';
import TrustBox from './TrustBox';
import './trust.scss';

/**
 * Trust Component
 * Title: Why Trust Us
 */
function Trust() {
   return (
      <div className="container-fluid trust">
         {/* <div className="row justify-content-center trust-heading">
            <h2>Why Trust Us</h2>
         </div> */}

         <div className="row justify-content-center trust-boxes">
            <TrustBox text="" image={1}/>
            <TrustBox text="Thanks, My son read the first 2 books in 3 days and wanted more.  I guess being stuck at home has some benefits." customer="- D.B. of C.I."  image={2}/>
            <TrustBox text="" image={3}/>
         </div>
      </div>
   )
}

export default Trust;